import {Brick, registerBrick, ErrorFlow} from 'olympe';

/**
 * This brick takes the result of the "Get Users" brick, and convert it into the Graph API syntax
 */
export default class ConvertUsersFromPGInGraphAPIFormat extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} pGResult
     * @param {function(string)} setGraphAPIFormat
     * @param {function(ErrorFlow)} setErrorFlow
     */
    update($, [pGResult], [setGraphAPIFormat, setErrorFlow]) {
        try {
            const parsedResult = JSON.parse(pGResult);

            setGraphAPIFormat(JSON.stringify({
                value: parsedResult.map((userInfo) => ({
                    givenName: userInfo.description.split(' ')[0],
                    surname: userInfo.description.slice(userInfo.description.indexOf(' ') + 1),
                    onPremisesSamAccountName: userInfo.id,
                    mail: userInfo.email,
                })),
            }));
        } catch (e) {
            setErrorFlow(ErrorFlow.create('Impossible to parse result from PG ' + e, 1004));
        }
    }
}

registerBrick('019320d7b0755e139b26', ConvertUsersFromPGInGraphAPIFormat);
